angular.module('app').directive('usuarioEndereco', function($http) {
	return {
        restrict: 'E',
        templateUrl: '/html/usuario-endereco.html?v='+angular.element('meta[name="version-id"]').attr('content'), 
        scope:{
            ngModel: '=',
        },
        controller: function($scope, $timeout) {
           
            $scope.init = function(){
                $http({
                    method: 'GET',
                    url: 'restrito/usuarios/me',   
                    ignorarCatchInterceptor: true,        
                }).then(function(res){
                    $scope.ngModel.cep = res.data.cep;
                    $scope.ngModel.logradouro = res.data.logradouro;
                    $scope.ngModel.numero = res.data.numero;
                    $scope.ngModel.complemento = res.data.complemento;
                    $scope.ngModel.bairro = res.data.bairro;
                    $scope.ngModel.uf = res.data.uf;
                    $scope.ngModel.municipio_id = res.data.municipio_id;
                })
            }

            $scope.changeCep = function(index){
                if (!$scope.ngModel.cep || $scope.ngModel.cep.length!==9) return false;        
                $http({
                    method: 'GET',
                    url: 'buscacep/' + $scope.ngModel.cep,            
                }).then(function(response) {
                    if (!response.data) return false;
                    $scope.ngModel.logradouro = response.data.logradouro;
                    $scope.ngModel.bairro = response.data.bairro;            
                    $scope.ngModel.municipio_id = response.data.ibge ? Number(response.data.ibge) : null;
                    $scope.ngModel.uf = response.data.uf;
                });
        
                return false; 
            };
            
        },
        link: function ($scope, $element, attrs, ctrl) {
            if(!attrs.naoInicializar){
                $scope.init();
            }
        }
    };
})